import { autoinject } from 'aurelia-framework';
import { Auth0Provider } from '../../../services/authentication/auth0-provider';

@autoinject
export class Auth0Login {

    constructor(auth: Auth0Provider) {    
        auth.redirectToLogin("login");
    }
}